/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { OpportunityDataSet } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function OpportunityDataSetUpdateForm(props) {
  const {
    id: idProp,
    opportunityDataSet: opportunityDataSetModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    DataSetName: "",
    InputIntoCapitalDeploymentAndFunding: "",
  };
  const [DataSetName, setDataSetName] = React.useState(
    initialValues.DataSetName
  );
  const [
    InputIntoCapitalDeploymentAndFunding,
    setInputIntoCapitalDeploymentAndFunding,
  ] = React.useState(initialValues.InputIntoCapitalDeploymentAndFunding);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = opportunityDataSetRecord
      ? { ...initialValues, ...opportunityDataSetRecord }
      : initialValues;
    setDataSetName(cleanValues.DataSetName);
    setInputIntoCapitalDeploymentAndFunding(
      cleanValues.InputIntoCapitalDeploymentAndFunding
    );
    setErrors({});
  };
  const [opportunityDataSetRecord, setOpportunityDataSetRecord] =
    React.useState(opportunityDataSetModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(OpportunityDataSet, idProp)
        : opportunityDataSetModelProp;
      setOpportunityDataSetRecord(record);
    };
    queryData();
  }, [idProp, opportunityDataSetModelProp]);
  React.useEffect(resetStateValues, [opportunityDataSetRecord]);
  const validations = {
    DataSetName: [],
    InputIntoCapitalDeploymentAndFunding: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          DataSetName,
          InputIntoCapitalDeploymentAndFunding,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(
            OpportunityDataSet.copyOf(opportunityDataSetRecord, (updated) => {
              Object.assign(updated, modelFields);
            })
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "OpportunityDataSetUpdateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Climate Related Opportunities"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="NZCS1 paragraph 14 b-c."
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Heading>
      <Text
        children="Update this record that collates data about the Opportunities you have identified, which have the potential to have a substantive financial or strategic impact on your business."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <TextField
        label="Name of opportunities records (e.g. 2025 climate-related opportunities records)"
        isRequired={false}
        isReadOnly={false}
        value={DataSetName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName: value,
              InputIntoCapitalDeploymentAndFunding,
            };
            const result = onChange(modelFields);
            value = result?.DataSetName ?? value;
          }
          if (errors.DataSetName?.hasError) {
            runValidationTasks("DataSetName", value);
          }
          setDataSetName(value);
        }}
        onBlur={() => runValidationTasks("DataSetName", DataSetName)}
        errorMessage={errors.DataSetName?.errorMessage}
        hasError={errors.DataSetName?.hasError}
        {...getOverrideProps(overrides, "DataSetName")}
      ></TextField>
      <Heading
        children="NZCS1 paragraph 14c."
        {...getOverrideProps(overrides, "SectionalElement5")}
      ></Heading>
      <TextAreaField
        label="Input into internal capital deployment and funding decision-making processes"
        isRequired={false}
        isReadOnly={false}
        value={InputIntoCapitalDeploymentAndFunding}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName,
              InputIntoCapitalDeploymentAndFunding: value,
            };
            const result = onChange(modelFields);
            value = result?.InputIntoCapitalDeploymentAndFunding ?? value;
          }
          if (errors.InputIntoCapitalDeploymentAndFunding?.hasError) {
            runValidationTasks("InputIntoCapitalDeploymentAndFunding", value);
          }
          setInputIntoCapitalDeploymentAndFunding(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "InputIntoCapitalDeploymentAndFunding",
            InputIntoCapitalDeploymentAndFunding
          )
        }
        errorMessage={errors.InputIntoCapitalDeploymentAndFunding?.errorMessage}
        hasError={errors.InputIntoCapitalDeploymentAndFunding?.hasError}
        {...getOverrideProps(overrides, "InputIntoCapitalDeploymentAndFunding")}
      ></TextAreaField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || opportunityDataSetModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || opportunityDataSetModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
